import { AxiosInstance as api } from '@service/axios-instance';

export interface DebugMachineStatus {
    id: string;
    tid: string;
    name: string;
    modelo: string;
    has_boot_anomaly: boolean;
    is_upload_pending: boolean;
    coredump_count: number;
}

export interface CoredumpMetadata {
    filename: string;
    has_elf: boolean;
    elf_file: string | null;
}

const getDb = () => localStorage.getItem('selectedDB') || '';

export const getDebugStatus = async (): Promise<DebugMachineStatus[]> => {
    const res = await api.get(`/debug-firmware/status?db=${getDb()}`, { withCredentials: true });
    return res.data;
};

export const triggerCoredumpUpload = async (id: string, tid: string): Promise<void> => {
    await api.post(`/debug-firmware/trigger-upload?db=${getDb()}`, { id, tid }, { withCredentials: true });
};

export const listCoredumps = async (tid: string): Promise<CoredumpMetadata[]> => {
    const res = await api.get(`/debug-firmware/coredumps/${tid}?db=${getDb()}`, { withCredentials: true });
    return res.data;
};

export const analyzeCoredump = async (filename: string): Promise<string> => {
    const res = await api.post(`/debug-firmware/analyze?db=${getDb()}`, { filename }, { withCredentials: true });
    return res.data?.output || 'No output';
};

export const deleteCoredump = async (filename: string): Promise<void> => {
    await api.delete(`/debug-firmware/coredump/${filename}?db=${getDb()}`, { withCredentials: true });
};
